// /pages/carrossier/FormulaireB/components/SectionVehicule.js
import React from "react";
import InputField from "./shared/InputField";

const SectionVehicule = ({ formData, handleChange, errors }) => {
  return (
    <section className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold mb-6 text-green-600 flex items-center gap-2">
        <span className="text-xl">🚛</span>
        3. Informations véhicule
      </h3>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <select
            value={formData.vehicule?.Type || ""}
            onChange={(e) => handleChange("vehicule", "Type", e.target.value)}
            className={`w-full px-4 py-3 border rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors ${
              errors["vehicule.Type"] ? 'border-red-500' : 'border-gray-200'
            }`}
            required
          >
            <option value="">Sélectionner le type de véhicule *</option>
            <option value="Porteur">Porteur</option>
            <option value="Semi">Semi-remorque</option>
            <option value="Autre">Autre</option>
          </select>
          {errors["vehicule.Type"] && (
            <p className="text-red-500 text-xs mt-1">{errors["vehicule.Type"]}</p>
          )}
        </div>
        <InputField
          section="vehicule"
          field="NumeroImmatriculation"
          placeholder="N° d'immatriculation"
          type="text"
          formData={formData}
          handleChange={handleChange}
          errors={errors}
        />
        <InputField
          section="vehicule"
          field="MarqueCaisse"
          placeholder="Marque de la caisse"
          type="text"
          formData={formData}
          handleChange={handleChange}
          errors={errors}
        />
        <InputField
          section="vehicule"
          field="NumeroIdentificationCaisse"
          placeholder="N° d'identification de la caisse"
          type="text"
          formData={formData}
          handleChange={handleChange}
          errors={errors}
        />
      </div>
    </section>
  );
};

export default SectionVehicule;